export const fields = {
  name: {
    label: 'Name',
    rules: 'required',
    placeholder: 'Name of the runbook'
  },
  description: {
    label: 'Description',
    placeholder: 'Description of the runbook'
  },
  display_md: {
    label: 'Instructions',
    placeholder: 'Runbook instructions in Markdown format'
  },
  comment: {
    label: 'Comment',
    placeholder: 'Comment describing the changes made in this edit'
  }
};
